var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpenInNewTab(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5514 3.11714C17.8404 3.40613 17.8404 3.87467 17.5514 4.16366L8.39363 13.3213C8.10464 13.6102 7.63609 13.6102 7.34711 13.3213C7.05812 13.0323 7.05813 12.5637 7.34712 12.2747L16.5049 3.11713C16.7939 2.82814 17.2624 2.82815 17.5514 3.11714Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.96826 5.72242C2.96826 5.31373 3.29957 4.98242 3.70826 4.98242H9.60497C10.0137 4.98242 10.345 5.31373 10.345 5.72242C10.345 6.13111 10.0137 6.46242 9.60497 6.46242H4.44826V16.221H14.2068V10.6243C14.2068 10.2156 14.5381 9.88434 14.9468 9.88434C15.3555 9.88434 15.6868 10.2156 15.6868 10.6243V16.961C15.6868 17.3697 15.3555 17.701 14.9468 17.701H3.70826C3.29957 17.701 2.96826 17.3697 2.96826 16.961V5.72242Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9587 3.64039C12.9587 3.2317 13.29 2.90039 13.6987 2.90039H17.0283C17.437 2.90039 17.7683 3.2317 17.7683 3.64039V6.96994C17.7683 7.37863 17.437 7.70994 17.0283 7.70994C16.6196 7.70994 16.2883 7.37863 16.2883 6.96994V4.38039H13.6987C13.29 4.38039 12.9587 4.04908 12.9587 3.64039Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenInNewTab);
export default __webpack_public_path__ + "static/media/open-in-new-tab.7eaba596aaa57820cb4bc6efaf3a27f3.svg";
export { ForwardRef as ReactComponent };